import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchBeginLoadOrders } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";

addToChainAfter(chain, DispatchBeginLoadOrders, props => {
    props.dispatch({
        type: "Custom/OrderHistory/SetOptionSelected",
        tabSelected: 0,
    } as any);
});
